import { Button, Flex, Typography } from "antd";
import DataTableQuery from "../components/DataTable/DataTableQuery";
import { useGetProductGroupsQuery } from "../../api/product/productsApi";
import { ColumnsType } from "antd/es/table";
import { ProductGroup } from "../../api/product/productTypes";
import { useState } from "react";
import EditProductModal from "./editProductModal";

const { Title } = Typography;

const newPgTemplate: ProductGroup = {
  Id: "",
  Name: "",
  DefaultProductDescription: "",
  ImageUrl: "",
  SimType: "esim",
  Type: "country",
  ProductIds: []
};

export default function ProductGroupsPage() {
  const [editProduct, setEditProduct] = useState<ProductGroup>();

  const columns: ColumnsType<ProductGroup> = [
    {
      key: "Name",
      title: "Country / Region Name",
      dataIndex: "Name"
    },
    {
      key: "SimType",
      title: "SIM Type",
      dataIndex: "SimType"
    },
    {
      key: "ProductIds",
      title: "# of products",
      dataIndex: "ProductIds",
      render: (value: string[]) => value.length
    },
    {
      key: "action",
      title: "Action",
      render: (rec: ProductGroup) => (
        <Button onClick={() => setEditProduct(rec)}>
          Edit
        </Button>
      )
    }
  ]

  function handleCreate() {
    setEditProduct({ ...newPgTemplate });
  }

  function handleClose() {
    setEditProduct(undefined);
  }

  function searchFilter(pg: ProductGroup, s: string) {
    return pg.Name.toLowerCase().includes(s.toLowerCase());
  }

  const isCreating = editProduct && editProduct.Id.length === 0;

  return <>
    <Flex gap={8} vertical>
      <Title level={2}>Products Management</Title>
      <DataTableQuery
        query={useGetProductGroupsQuery}
        columns={columns}
        searchFilter={searchFilter}
        onCreate={handleCreate}
      />
      <EditProductModal
        title={isCreating ? "Create Product" : "Edit Product"}
        pg={editProduct}
        setPg={setEditProduct}
        onClose={handleClose}
      />
    </Flex>
  </>
}